/**
 * React Query client configuration
 * Story 198: View and filter stories in backlog
 */

import { QueryClient } from '@tanstack/react-query';

/** Stale time for queries (5 minutes) */
const STALE_TIME_MS = 5 * 60 * 1000;

/** Retry delay calculation */
const RETRY_DELAY_BASE_MS = 1000;

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: STALE_TIME_MS,
      retry: 2,
      retryDelay: (attemptIndex) => Math.min(
        RETRY_DELAY_BASE_MS * 2 ** attemptIndex,
        30000
      ),
    },
  },
});
